// extracted by mini-css-extract-plugin
export default {"card":"InventoryDetailPanel_card__I1Vr1","section":"InventoryDetailPanel_section__+wACn"};